module.exports = __webpack_public_path__ + "img/etica.22756920.svg";